import { ref } from 'vue'

export type Theme = 'light' | 'dark'

export const theme = ref<Theme>(
  document.documentElement.getAttribute('data-bs-theme') === 'dark' ? 'dark' : 'light'
)

export function setTheme(value: Theme) {
  theme.value = value
  document.documentElement.setAttribute('data-bs-theme', value)
  document.documentElement.setAttribute('data-theme', value)

  try {
    localStorage.setItem('rpm-theme', value)
  } catch (_) {
    // El cambio sigue funcionando durante esta visita.
  }
}

export function toggleTheme() {
  setTheme(theme.value === 'dark' ? 'light' : 'dark')
}
